import { consoleLogger } from '@shared/logging/consoleLogger';
import { QueueCommand } from '@utiqLoader/types';

const nonDuplicableCallbackKeys = [
  'showConsentManager',
  'revokeConsentWithPopup',
  'showConsentModal',
];

const preventDuplicatedCommandExecution = (
  commandA: QueueCommand,
  commandB: QueueCommand,
): boolean => {
  if (
    typeof commandB === 'function' &&
    nonDuplicableCallbackKeys.some((key) => commandB.toString().includes(key))
  ) {
    if (typeof commandA === 'function') {
      return commandA.toString() === commandB.toString();
    }
  }

  return false;
};

const executeCommand = (
  command: QueueCommand,
  executedCommands: QueueCommand[],
) => {
  const isNonDuplicableCommandAlreadyInQueue = executedCommands.some((c) =>
    preventDuplicatedCommandExecution(c, command),
  );
  if (typeof command === 'function' && !isNonDuplicableCommandAlreadyInQueue) {
    // Case an Asynchronous callback is being called
    consoleLogger.logDebug('Executing Asynchronous queued callback');
    executedCommands.push(command);
    command();
  }
};

const lazyLoadQueue = () => {
  const executedCommands: QueueCommand[] = [];
  window.Utiq ||= {};
  window.Utiq.queue ||= [];
  window.Utiq.queue.forEach((command: QueueCommand) =>
    executeCommand(command, executedCommands),
  );
  window.Utiq.queue.length = 0;
  executedCommands.length = 0;
};

export const initializeCommandQueue = () => {
  lazyLoadQueue();
  window.Utiq ||= {};
  window.Utiq.queue ||= [];
  window.Utiq.queue.push = (command: QueueCommand) => {
    const length = Array.prototype.push.call(window.Utiq!.queue, command);
    lazyLoadQueue();
    return length;
  };
};
